export default {
  nav: {
    overview: "Overview",
    products: "Products",
    licenses: "My Licenses",
    status: "Status",
    activity: "Activity",
    admin: "Admin",
    quickApply: "Apply",
    login: "Sign in / Sign up",
    notifications: "Notifications",
    settings: "Settings",
    signOut: "Sign out",
    language: "Language",
    adminProducts: "Product Admin",
    adminTools: "License Tools",
    adminCustomers: "Customers",
    adminAudit: "Audit Log",
    adminMonitor: "Monitoring",
    adminStaff: "Staff",
    adminReports: "Report Center",
    adminApiKeys: "API Clients",
    adminApprovals: "Approvals & Webhooks",
    adminHelp: "Help feedback",
    brandHome: "LicenseHub home",
    openMenu: "Open menu",
    userMenu: "User menu",
  },
  hero: {
    badge: "Genuine software licensing · all-in-one",
    titleLead: "Make every genuine license",
    titleHighlight: "clear and controllable",
    subtitle:
      "From application and issuance to monitoring and reporting, LicenseHub connects customers and admins in one system, keeping every license visible and traceable.",
    login: "Sign in",
    apply: "Request a license",
    statCustomers: "Customers",
    statActive: "Active licenses",
    statSeats: "Online seats",
    imgAlt: "LicenseHub licensing platform background",
    imgTitle: "LicenseHub genuine software licensing platform",
  },
  overview: {
    active: "Active licenses",
    activeSub: "{{total}} licenses in total",
    pending: "Pending applications",
    pendingSub: "Needs prompt handling",
    issued: "Issued this month",
    issuedSub: "Licenses issued this month",
    expiring: "Expiring soon",
    expiringSub: "Active licenses expiring in 30 days",
    expiringCta: "View renewal list",
    customers: "Total customers",
    customersSub: "Registered and active customers",
    customersCta: "Go to customers",
    pendingCustomers: "Customers to review",
    pendingCustomersSub: "Customers with pending applications",
    pendingCustomersCta: "View pending customers",
    seats: "Online seats",
    seatsSub: "Currently activated devices",
  },
  status: {
    eyebrow: "System status",
    title: "License operations at a glance",
    description:
      "Track activation trends, license issuance and platform uptime in real time, so anomalies surface immediately.",
    trendTitle: "30-day licensing trend",
    trendSub: "Device activations and licenses issued",
    legendActivation: "Activations",
    legendIssued: "Issued",
    distTitle: "License status distribution",
    distSub: "Composition of all current licenses",
    empty: "No data",
    statRequests: "API requests today",
    statUptime: "Average uptime",
    statIssued: "Issued in 30 days",
    active: "Active",
    expired: "Expired",
    suspended: "Suspended",
    revoked: "Revoked",
  },
  activity: {
    eyebrow: "Recent activity",
    title: "License events in real time",
    description:
      "Approvals, issuance, activations and alerts in one place, filterable by status with one-click report export.",
    eventStream: "Event stream",
    realtime: "Live",
    exportBtn: "Export report",
    exporting: "Exporting…",
    exportedToast: "Exported {{num}} license records",
    exportFailed: "Export failed, please retry",
    filterAll: "All",
    levelSuccess: "Success",
    levelWarning: "Warning",
    levelError: "Error",
    levelInfo: "Info",
    reload: "Reload",
    empty: "No matching activity",
    pendingTitle: "Pending applications",
    pendingSub: "Timely approval improves customer experience",
    goAdmin: "Go to admin",
    quickTitle: "Shortcuts",
    quickApply: "Submit application",
    quickProducts: "Product center",
    quickLicenses: "License center",
    quickMonitor: "Monitor status",
    quickHelp: "Help center",
    system: "System",
  },
  help: {
    eyebrow: "Help center",
    title: "Need help? We are here",
    description:
      "From onboarding to advanced usage, the help center covers everything about license management.",
    viewDetail: "View details",
    i1Title: "Quick start",
    i1Desc: "Sign up, apply for a license and receive it in three steps.",
    i2Title: "FAQ",
    i2Desc: "Answers on license scope, seat changes, migration and more.",
    i3Title: "Documentation",
    i3Desc: "Complete guides and best practices for admins and customers.",
    i4Title: "Submit a ticket",
    i4Desc: "Contact support anytime when issuance or activation goes wrong.",
    noAnswer: "Still have questions?",
    contactDesc: "Reach our license support team, usually replied within one business day.",
    contact: "Contact us",
  },
  helpCenter: {
    breadcrumbHome: "Home",
    breadcrumbCurrent: "Help center",
    badge: "Self-service · FAQ · Integration guides",
    title: "Help center",
    subtitle:
      "From sign-up and application to issuance and activation, plus renewal and API integration, the most used guides and common questions are collected here.",
    searchPlaceholder: "Search keywords, e.g. renewal, machine code, 429…",
    searchClear: "Clear",
    heroSearchLabel: "Search the help center",
    heroSearchButton: "Search",
    heroSearchHot: "Popular",
    hotTag1: "activation",
    hotTag2: "renewal",
    hotTag3: "machine code",
    hotTag4: "429",
    hotTag5: "API integration",
    navQuickstart: "Quick start",
    navFaq: "FAQ",
    navDocs: "Integration docs",
    navContact: "Contact support",
    quickEyebrow: "Quick start",
    quickTitle: "Get licensed in four steps",
    quickDesc: "Follow these steps in order to go from sign-up all the way to device activation.",
    quickStepTag: "STEP {{num}}",
    step1Title: "Create an account",
    step1Desc: "Click \"Log in / Sign up\" at the top right and register with your email.",
    step1Cta: "Log in / Sign up",
    step2Title: "Submit a license application",
    step2Desc: "Pick a product and version, then fill in seat count and device machine code.",
    step2Cta: "Go to application",
    step3Title: "Wait for approval",
    step3Desc: "Verification usually finishes within 1-2 business days; you are notified by email and in-app notice.",
    step3Cta: "View my applications",
    step4Title: "Claim and activate the license",
    step4Desc: "Copy the key or download the file in the license center, then enter the machine code to activate.",
    step4Cta: "Open license center",
    faqEyebrow: "FAQ",
    faqTitle: "Frequently asked questions",
    faqDesc: "Browse by category or search keywords to find what you need quickly.",
    faqAll: "All",
    faqCatAccount: "Account & sign-in",
    faqCatApply: "License application",
    faqCatLicense: "Licenses & activation",
    faqCatRenewal: "Expiry & renewal",
    faqCatIntegration: "Integration",
    faqResultCount: "{{count}} related answers",
    faqRecentTitle: "Recently viewed",
    faqRecentClear: "Clear",
    faqCopyLink: "Copy search link",
    faqLinkCopied: "Link copied",
    faqEmpty: "No matching questions",
    faqEmptyDesc: "Try another keyword, or submit a ticket and our team will help you.",
    faqReset: "Reset filters",
    faqContactCta: "Still stuck? Submit a ticket",
    faqCopyItem: "Copy question link",
    faqItemLinkCopied: "Question link copied",
    faqHelpfulQuestion: "Was this answer helpful?",
    faqHelpful: "Helpful",
    faqNotHelpful: "Not helpful",
    faqFeedbackThanks: "Thanks for your feedback",
    faqNotHelpfulHint: "Jumped to the ticket form and pre-filled the issue type",
    faqRecentBadge: "Recently viewed",
    faqRecentlyUpdated: "Recently updated",
    faqRecentlyUpdatedTitle: "This answer was updated recently ({{time}})",
    q1: "How do I sign up and log in?",
    a1: "Click \"Log in / Sign up\" at the top right and register with your email; existing accounts can log in directly.",
    q2: "What if I forgot my password?",
    a2: "Click \"Forgot password\" on the login page, enter your registered email, and follow the reset link to set a new password.",
    q3: "I am not receiving email notifications.",
    a3: "Check your spam folder and make sure the account email is correct; if it still fails, submit a ticket so we can check the delivery status.",
    q4: "How do I submit a license application?",
    a4: "Click \"Quick apply\" at the top, choose a product and version, then fill in seat count, machine code and usage notes before submitting.",
    q5: "How long does approval take?",
    a5: "Verification usually completes within 1-2 business days; track progress in \"My licenses\" or \"My applications\".",
    q6: "Where can I find the machine code?",
    a6: "Open the target software and find it under \"Help → License info\" to copy the machine code; enter seat count based on actual devices.",
    q7: "How many seats should I enter?",
    a7: "Enter the number of devices you actually need to activate; the license seats are generated based on this number after approval.",
    q8: "How do I claim the license after approval?",
    a8: "It is issued automatically after approval; open \"My licenses\" to view the key, copy it, or download the license file.",
    q9: "How do I activate a new device?",
    a9: "Open the license \"Device activation detail\", click \"Activate new device\", and enter the machine code (device name, OS and location are optional).",
    q10: "Do I need to buy again after switching computers?",
    a10: "No. Release the activation on the old device first, then enter the new machine code on the new device; the seat is freed and reused automatically.",
    q11: "It says \"activation seats are full\" — what now?",
    a11: "First unbind devices you no longer use to free up seats; if you truly need more, submit a seat-increase application.",
    q12: "Will I be reminded before a license expires?",
    a12: "Yes. We notify you by in-app notice and email before expiry; you can also check the expiry planner in \"My licenses\".",
    q13: "How do I request a renewal?",
    a13: "Click \"Request renewal\" on the license card, enter the desired duration and submit; the term is extended automatically after approval.",
    q14: "Can I still use it after expiry?",
    a14: "After expiry the license check returns invalid and the client is blocked, so please renew in time to avoid disruption.",
    q15: "How do I integrate the online validation API?",
    a15: "Issue an API key in \"Admin → API clients\", then follow the \"Integration docs\" to call the validation API; the client only needs to check the valid field.",
    q16: "How do I license a device without internet?",
    a16: "Use the offline machine-locked code: the backend signs the code offline with a private key and the software verifies locally with a built-in public key, with no network needed.",
    q17: "The API returns 429 or rate limits.",
    a17: "This means the key's rate limit or daily quota is hit; adjust them in \"API clients\" or spread out the calls.",
    guidesEyebrow: "Tutorials",
    guidesTitle: "Curated guides and best practices",
    guidesDesc: "A few tried-and-true tips to run licensing smoothly — open a card to jump to the right module.",
    guide1Title: "Finish your first application in three minutes",
    guide1Desc: "From choosing a product to entering the machine code, a step-by-step walkthrough.",
    guide1Tag: "Beginner",
    guide2Title: "Keeping license keys safe",
    guide2Desc: "Keys are sensitive — how to store and distribute them without pitfalls.",
    guide2Tag: "Security",
    guide3Title: "Device migration and seat recycling",
    guide3Desc: "How to unbind old devices when upgrading or retiring hardware.",
    guide3Tag: "Ops",
    guide4Title: "Planning renewals ahead of expiry",
    guide4Desc: "Use the expiry planner to schedule renewals and avoid license outages.",
    guide4Tag: "Renewal",
    guide5Title: "Integration essentials for the validation API",
    guide5Desc: "Issue API keys and handle rate limits and failure codes correctly.",
    guide5Tag: "Integration",
    guide6Title: "Offline machine-locked codes for air-gapped setups",
    guide6Desc: "A practical approach using local public-key verification, fully offline.",
    guide6Tag: "Advanced",
    guideOpen: "View guide",
    docsTitle: "Integration docs for developers",
    docsDesc: "The validation API, request and response fields, reason codes, and a local verification reference for offline codes — all here.",
    docsBtn: "Open integration docs",
    contactEyebrow: "Submit a ticket",
    contactTitle: "Still not solved? Contact us",
    contactDesc: "Fill in the ticket below and the license support team usually replies within one business day.",
    contactPoint1Title: "Response time",
    contactPoint1Desc: "Within one business day",
    contactPoint2Title: "Support scope",
    contactPoint2Desc: "Application, issuance, activation and renewal",
    contactPoint3Title: "Self-service first",
    contactPoint3Desc: "Check the FAQ and guides above — most issues are solved there",
    formSuggestTitle: "Check these first — you may already find the answer",
    formSuggestHint: "These are the most relevant answers for this issue type; try them first, and submit the ticket if it still isn't solved.",
    formSuggestMore: "View all FAQs",
    formName: "Your name",
    formNamePlaceholder: "Enter your name",
    formEmail: "Contact email",
    formEmailPlaceholder: "you@example.com",
    formCompany: "Company / organization (optional)",
    formCompanyPlaceholder: "Enter your company or organization",
    formType: "Issue type",
    formTypePlaceholder: "Select an issue type",
    formTypeAccount: "Account & sign-in",
    formTypeApply: "License application",
    formTypeLicense: "Licenses & activation",
    formTypeRenewal: "Expiry & renewal",
    formTypeIntegration: "Integration",
    formTypeOther: "Other",
    formLicense: "Related license key (optional)",
    formLicensePlaceholder: "e.g. LH-XXXX-XXXX-XXXX-XXXX",
    formContent: "Describe your issue",
    formContentPlaceholder: "Describe the problem, the expected result and what you have tried (up to 500 characters)",
    formSubmit: "Submit ticket",
    formSubmitting: "Submitting…",
    formNote: "By submitting you agree that we may contact you via the email provided.",
    formSuccessTitle: "Ticket submitted",
    formSuccessDesc: "We have received your question and the support team will reply by email within one business day.",
    formAnother: "Submit another",
    formErrName: "Please enter your name",
    formErrEmail: "Please enter your contact email",
    formErrEmailFormat: "Email format is invalid",
    formErrType: "Please select an issue type",
    formErrContent: "Please describe your issue",
    formErrContentMax: "The description cannot exceed 500 characters",
    formErrFailed: "Submission failed, please try again later",
  },
  footer: {
    tagline:
      "An all-in-one genuine software licensing platform — from application and approval to issuance, monitoring and reporting, every license stays clear and controllable.",
    badgeSecurity: "Secure & compliant",
    badgeUptime: "99.9% uptime",
    colProduct: "Product",
    colHelp: "Help center",
    colSupport: "Get support",
    productApply: "License application",
    productLicenses: "License center",
    productMonitor: "Status monitoring",
    productReports: "Report export",
    helpGuide: "Quick start",
    helpFaq: "FAQ",
    helpDocs: "Integration docs",
    helpTicket: "Submit a ticket",
    supportDesc: "For licensing or issuance questions, the help center is here for you.",
    supportBtn: "Go to help center",
    copyright: "© 2026 LicenseHub. All rights reserved.",
    terms: "Terms of Service",
    privacy: "Privacy Policy",
    contact: "Contact us",
  },
  licenses: {
    breadcrumbHome: "Home",
    title: "My Licenses",
    subtitle: "View all licenses under your account, copy keys, check status and expiry, and track device activations.",
    applyNew: "Request a license",
    reload: "Reload",
    filterAll: "All",
    filterActive: "Active",
    filterExpiring: "Expiring soon",
    filterExpired: "Expired",
    filterInactive: "Suspended / Revoked",
    sourceLabel: "Source",
    sourceAll: "All sources",
    sourceApplication: "Approved",
    sourceRedeem: "Code redemption",
    emptyTitle: "You have no licenses yet",
    emptyTitleFiltered: "No licenses in this category",
    emptyDesc: "Submit an application and your license will appear here once approved.",
    emptyDescFiltered: "Try another filter to see licenses in other states.",
    emptyApply: "Request now",
    tip: "License keys are sensitive. Do not share them publicly. You can submit a new application anytime to migrate devices or add seats.",
    seatUnit: "{{count}} seats",
    sourceTipApplication: "Issued through license application approval",
    sourceTipRedeem: "Obtained via self-service code redemption",
    licenseKeyLabel: "License key",
    show: "Show",
    hide: "Hide",
    copyKey: "Copy key",
    copied: "Copied",
    deviceDetail: "Device activations",
    deviceDetailHint: "View activated devices — activate new ones or release for a swap",
    issuedAt: "Issued {{date}}",
    expiresAt: "Expires {{date}}",
    permanent: "Perpetual",
    expiringOnlyDays: "{{days}} days left",
    expiredRenew: "Expired — please renew",
    cardHint: "Download the license file, or request a renewal when expiring or expired.",
    downloadSuccess: "License file downloaded: {{file}}",
    downloadFailed: "Download failed, please retry",
    downloaded: "Downloaded",
    downloadFile: "Download license file",
    renewSubmitted: "Renewal submitted",
    renew: "Request renewal",
    renewSuccess: "Renewal submitted — the term extends automatically once approved",
    submitFailed: "Submission failed, please retry",
    statTotal: "Total licenses",
    statTotalHint: "Follows source filter",
    statActive: "Active",
    statExpiring: "Expiring in 30 days",
    statSeats: "Total seats",
    statRedeemPct: "Redemption share",
    statRedeemHint: "{{redeem}} redeemed · {{application}} approved",
    statRedeemCta: "Filter licenses from redemption",
    statRedeemActive: "Filtered to redeemed licenses · broken down below",
    redeemTitle: "Redeem activation code",
    redeemDesc: "Got a raw activation code (like XXXX-XXXX-XXXX-XXXX)? Enter it here to generate a dedicated license and add it to the list below.",
    redeemOnce: "One-time redemption",
    redeemPlaceholder: "XXXX-XXXX-XXXX-XXXX",
    redeemSubmit: "Redeem now",
    redeemSubmitting: "Redeeming…",
    redeemEmptyCode: "Please enter an activation code",
    redeemFailed: "Redemption failed, please retry",
    redeemSuccessTitle: "Redeemed — the license has been added to your account",
    redeemProduct: "Product",
    redeemEdition: "Edition",
    redeemSeats: "Seats",
    redeemTip: "Each code can be redeemed once and binds to your account. If you see 'already redeemed' or 'disabled', contact the issuer.",
    breakdownTitle: "Redemption source · by batch",
    breakdownSub: "See how many licenses each batch contributed via code redemption.",
    breakdownSortCount: "By count",
    breakdownSortRecent: "Recent",
    breakdownSortCountTitle: "Sort by redeemed count, high to low",
    breakdownSortRecentTitle: "Bring batches with recent activity to the top",
    breakdownTotal: "{{count}} total · {{batches}} batches",
    breakdownProduct: "Product",
    breakdownAllProducts: "All products",
    breakdownLoading: "Loading batch distribution…",
    breakdownEmpty: "No redemption source to break down by batch yet.",
    breakdownLastRedeemed: "Last redeemed: {{time}}",
    breakdownNeverRedeemed: "No redemptions yet",
    breakdownLastExport: "Last export: {{who}} · {{date}}",
    breakdownCopy: "Copy batch list",
    breakdownCopied: "List copied",
    breakdownCopyTitle: "Copy this batch's redeemed licenses to paste into a spreadsheet",
    breakdownDownload: "Download batch CSV",
    breakdownDownloaded: "List downloaded",
    breakdownDownloadTitle: "Download this batch's redeemed licenses as CSV (filename includes batch and date)",
    breakdownCountUnit: "{{count}} codes",
    breakdownFilterByProduct: "Only show contribution from '{{name}}'",
    breakdownGenericProduct: "General",
    batchListHeader: "Batch {{batch}} redemption list · {{count}} codes",
    colLicenseKey: "License key",
    colProduct: "Product",
    colEdition: "Edition",
    colSeats: "Seats",
    colRedeemedAt: "Redeemed at",
    redeemedFilePrefix: "redeemed-licenses",
    renewalTitle: "Request renewal",
    renewalDesc: "Once submitted, the platform receives your renewal request and extends the term automatically after approval.",
    renewalCurrentExpiry: "Current expiry",
    renewalExpiredSuffix: " (expired)",
    renewalNoteLabel: "Renewal note / expected term (optional)",
    renewalNotePlaceholder: "e.g. please renew for 12 months for the 2026 project",
    cancel: "Cancel",
    renewalSubmit: "Submit renewal request",
    renewalSubmitting: "Submitting…",
    plannerTitle: "Expiry planner",
    plannerSub: "Group your licenses by urgency and schedule renewals ahead to avoid interruptions.",
    plannerOverdue: "Expired",
    plannerUrgent: "Expiring in 30 days",
    plannerSoon: "Expiring in 90 days",
    plannerLater: "90+ days",
    plannerPerpetual: "Perpetual",
    plannerCount: "{{count}} licenses",
    plannerEmpty: "Nothing to plan yet",
    plannerEmptyDesc: "When you have licenses nearing expiry, their renewal priority shows up here.",
    plannerNext: "Next expiry",
    plannerDaysLeft: "Expires in {{days}} days",
    plannerOverdueDays: "Expired {{days}} days ago",
    plannerView: "View",
    plannerExport: "Export renewal list",
    plannerExported: "Exported",
    plannerExportTitle: "Export licenses that need renewal as CSV for your ledger",
    plannerExportFileName: "renewal-list",
    plannerColProduct: "Product",
    plannerColEdition: "Edition",
    plannerColKey: "License key",
    plannerColExpiry: "Expiry",
    plannerColDaysLeft: "Days left",
    plannerColStatus: "Status",
    plannerColUrgency: "Urgency",
  },
  timeline: {
    title: "License change timeline",
    sub: "Issuance, renewal and device changes replayed in reverse chronological order for full traceability.",
    toggleShow: "Show timeline",
    toggleHide: "Hide timeline",
    filterAll: "All",
    filterNoMatch: "No changes of this type",
    count: "{{count}} changes",
    typeIssued: "License issued",
    typeRenewed: "Renewed",
    typeActivated: "Device activated",
    typeReleased: "Device released",
    empty: "No changes yet",
    emptyDesc: "Issuance, renewal and device activation/release events will replay here over time.",
    licenseTag: "License",
    deviceTag: "Device",
    loadFailed: "Failed to load change history, please retry",
  },
  edition: {
    standard: "Standard",
    professional: "Professional",
    enterprise: "Enterprise",
  },
  licenseStatus: {
    active: "Active",
    expired: "Expired",
    suspended: "Suspended",
    revoked: "Revoked",
  },
  licenseSource: {
    application: "Approved",
    redeem: "Code redemption",
  },
  time: {
    justNow: "Just now",
  },
  device: {
    panelTitle: "Device activations · {{product}}",
    summary: "{{active}} activated, {{max}} allowed, {{left}} seats left. Enter a machine code to self-activate; when swapping, release the old device first.",
    activateNew: "Activate device",
    activateSeatsUsed: "No seats left — release another device first",
    activateTitle: "Activate a new device with its machine code",
    exportList: "Export devices",
    exported: "Exported",
    exportEmpty: "No devices to export",
    exportTitle: "Export this license's devices as CSV",
    cleanInactive: "Clean inactive",
    cleanNoInactive: "No devices inactive for over {{days}} days",
    cleanTitle: "Release {{count}} devices inactive for over {{days}} days to reclaim seats",
    close: "Collapse device details",
    cleanConfirm: "This will release {{count}} devices inactive for over {{days}} days. Reclaimed seats can be used immediately. The action is written to the activity log and visible in the timeline.",
    cancel: "Cancel",
    cleaning: "Cleaning…",
    confirmUnbind: "Release {{count}} devices",
    activateForm: "Activate with machine code · {{left}} seats left",
    machineCode: "Machine code",
    machineCodePlaceholder: "e.g. 9A2F-77C1-B3D4-005E",
    deviceName: "Device name (optional)",
    deviceNamePlaceholder: "e.g. John's workstation",
    os: "Operating system (optional)",
    osPlaceholder: "e.g. Windows 11 / macOS 14",
    location: "Location (optional)",
    locationPlaceholder: "e.g. Shanghai · R&D center",
    confirmActivate: "Confirm activation",
    activating: "Activating…",
    statusAll: "All",
    statusActive: "Active",
    statusReleased: "Released",
    timeAll: "All time",
    time7d: "Last 7 days",
    time30d: "Last 30 days",
    summaryCount: "{{total}} total · {{filtered}} after filter",
    reload: "Reload",
    emptyNoDevice: "No activated devices yet",
    emptyNoMatch: "No activated devices match the filter",
    emptyNoDeviceDesc: "Click 'Activate device' above to enter a machine code, or activate with the license key in the software.",
    emptyNoMatchDesc: "Adjust the status or time filter above.",
    save: "Save",
    rename: "Rename device",
    lastSeen: "Last active {{time}}",
    confirmRelease: "Release this device's activation?",
    confirmReleaseBtn: "Release",
    processing: "Processing…",
    releaseBtn: "Release",
    timelineTitle: "Activation / release timeline ({{count}})",
    batchClean: "System batch cleanup · {{count}} reclaimed",
    batchTag: "Batch",
    expandBatch: "Expand to view the devices reclaimed in this cleanup",
    jumpDevice: "Jump to this device",
    eventRelease: "Released device",
    eventActivate: "Activated device",
    tagSelfRelease: "Self release",
    tagSelfActivate: "Self activate",
    releasedDevices: "Released devices ({{count}})",
    sourceBatch: "System batch cleanup",
    sourceSelf: "Self release",
    releaseSuccess: "Released '{{name}}', the seat is now free",
    releaseFailed: "Release failed, please retry",
    renameSuccess: "Device name updated",
    renameFailed: "Rename failed, please retry",
    needMachineCode: "Please enter the device machine code",
    activateSuccess: "Device activated, {{left}} seats left",
    activateFailed: "Activation failed, please retry",
    cleanSuccess: "Released {{count}} inactive devices, reclaimed {{count}} seats",
    cleanNone: "No inactive devices match the criteria",
    cleanFailed: "Batch release failed, please retry",
    colDevice: "Device name",
    colMachine: "Machine code",
    colOs: "OS",
    colLocation: "Location",
    colStatus: "Status",
    colActivated: "Activated at",
    colLastSeen: "Last active",
    colReleased: "Released at",
    colReleaseSource: "Release source",
    csvFileName: "devices",
  },
  tools: {
    breadcrumbHome: "Home",
    breadcrumbAdmin: "Admin",
    badge: "Issuance toolkit",
    title: "License Tools",
    subtitle: "Generate one-time raw activation codes for distribution, or offline per-machine codes for disconnected environments. Every action is written to the audit log.",
    docs: "Integration docs",
    reload: "Reload",
    tabPool: "Raw code pool",
    tabOffline: "Offline per-machine",
  },
  adminHome: {
    breadcrumbHome: "Home",
    badge: "Admin console",
    title: "License Admin",
    subtitle: "Review applications, issue and revoke licenses in one place. Approvals auto-issue a key and email the applicant.",
    pendingPrefix: "",
    pendingSuffix: "applications awaiting review",
    exportAll: "Export all licenses",
    exportEmpty: "No licenses to export right now",
    exportDone: "Exported {{num}} license records (including revoked)",
    reload: "Reload",
    tabApplications: "Applications",
    tabLicenses: "Licenses",
    tip: "Approving auto-generates a license key and emails the applicant. If emails fail, make sure the Resend domain is configured in Email settings.",
    moduleProducts: "Product Admin",
    moduleTools: "License Tools",
    moduleReports: "Report Center",
    moduleCustomers: "Customers",
    moduleAudit: "Audit Log",
    moduleMonitor: "Monitoring",
    moduleStaff: "Staff",
    moduleApiKeys: "API Clients",
    moduleApprovals: "Approvals & Webhooks",
    moduleHelp: "Help feedback",
  },
  reports: {
    breadcrumbHome: "Home",
    breadcrumbAdmin: "Admin",
    title: "Report Center",
    badge: "Unified export entry",
    subtitle: "Gather every CSV export scattered across the console into one entry: one-click reports generate files instantly, filter-dependent reports link to their module, and every export leaves a traceable task history.",
    backToAdmin: "Back to admin",
    reload: "Reload",
    statTotal: "Total export tasks",
    statMonth: "Exported this month",
    statRunnable: "One-click reports",
    statRows: "Total rows exported",
    batchTitle: "Batch export",
    batchSubtitle: "Select several reports to package in one go, summarized into a single export task for archiving and monthly audit.",
    batchSelectAll: "Select all",
    batchClear: "Clear",
    batchSelected: "{{count}} selected",
    batchGenerate: "Generate {{count}} reports",
    batchRunning: "Generating…",
    batchEmpty: "Select at least one report to export",
    batchDone: "Generated {{count}} reports, {{rows}} rows in total",
    batchFailed: "Batch export failed, please retry",
    batchConfirmTitle: "Confirm batch export scope",
    batchConfirmSub: "These {{count}} reports will be generated in one go. Check the names and estimated rows to avoid an accidental large export.",
    batchConfirmEstimate: "~{{rows}} rows",
    batchConfirmTotalLabel: "Estimated total rows",
    batchConfirmTotal: "~{{rows}} rows",
    batchConfirm: "Confirm export",
    batchCancel: "Cancel",
    batchConfirmLargeTitle: "High estimated row count",
    batchConfirmLargeBody: "This batch export is about {{rows}} rows in total — a large scope that may take a while. Confirm you really need to export this much at once, or deselect some reports and retry.",
    healthWindowTitle: "Health snapshot window",
    healthWindowHint: "The endpoint health snapshot is generated for the selected window; single generate and batch export share it, and the export history carries the window label.",
    healthWindowInlineLabel: "Time window",
    catalogRunnable: "{{category}} reports",
    catalogCount: "{{count}} available · one-click",
    catalogLinksTitle: "More exports · go to module",
    catalogLinksSub: "Reports with filters are more flexible on their source page",
    catalogGo: "Go to export",
    generate: "Generate CSV",
    generating: "Generating…",
    runnableDone: "\"{{name}}\" generated, {{rows}} rows",
    runnableFailed: "Report generation failed, please retry",
    historyTitle: "Export task history",
    historySub: "Records who exported a report or pushed renewal reminders, with time and volume, grouped by month and filterable by category, exporter and time range.",
    historyExport: "Export history",
    historyCount: "{{count}} tasks · {{rows}} rows",
    historyFilterAll: "All records",
    historyFilterRenewal: "Reminder pushes only",
    historyAllCategory: "All categories",
    historyAllExporter: "All exporters",
    historyClear: "Clear filters",
    historyExpandAll: "Expand all",
    historyCollapseAll: "Collapse all",
    historyMonthSummary: "{{count}} tasks · {{rows}} rows",
    historyEmpty: "No export tasks yet",
    historyEmptyDesc: "Generate a report above or push renewal reminders from customer management, and each action will be recorded here with its operator and time.",
    historyNoMatch: "No records under current filters",
    historyNoMatchDesc: "Try relaxing the category, exporter or time range.",
    colTime: "Exported at",
    colExporter: "Exporter",
    colReport: "Report",
    colCategory: "Category",
    colRows: "Rows",
    historyWindowTag: "Window: {{window}}",
    unknown: "Unknown",
    others: "Other",
    rangeAll: "All time",
    rangeToday: "Today",
    range7d: "Last 7 days",
    range30d: "Last 30 days",
    catLicense: "License",
    catCode: "Codes",
    catCustomer: "Customer",
    catAudit: "Audit",
    catMonitor: "Monitoring",
    catBatch: "Batch",
  },
  apply: {
    breadcrumbHome: "Home",
    breadcrumbCurrent: "License application",
    title: "Submit a license application",
    subtitle: "Fill in product, version, seats and machine code. Once submitted it enters review, fully trackable in the license center.",
    flowTitle: "How it works",
    step1Title: "Submit",
    step1Desc: "Pick product and version, enter seats and machine code",
    step2Title: "Review",
    step2Desc: "Details verified within 1-2 business days",
    step3Title: "Issue license",
    step3Desc: "A dedicated license key is issued automatically on approval",
    step4Title: "Download & activate",
    step4Desc: "Download the key in the license center and activate devices",
    tipsTitle: "Good to know",
    tip1: "The machine code is shown in the software's license info",
    tip2: "Enter seats based on actual deployed devices",
    tip3: "For Enterprise, describe the scale in the notes",
    tip4: "The review result is emailed to the address you provide",
    helpTitle: "Need help?",
    helpDesc: "Not sure which version to pick or how to fill the form? Browse the product center first for details.",
    browseProducts: "Browse the product center",
    infoTitle: "License details",
    archivedTitle: "This product is no longer licensed",
    archivedDesc: "\"{{name}}\" has been delisted and no longer accepts new applications; your previous applications remain viewable under 'My applications' below. Pick an available product from the suggestions or choose another one.",
    product: "Product",
    productPlaceholder: "Select a product",
    productLoading: "Loading…",
    version: "Version",
    versionPlaceholder: "Select a version",
    versionFirst: "Select a product first",
    edition: "Edition",
    seats: "Seats",
    seatsPlaceholder: "e.g. 10",
    machine: "Machine code",
    machinePlaceholder: "MC-XXXX-XXXX",
    machineHint: "Find the device machine code under Help - License info in the software",
    useCase: "Use case",
    useCasePlaceholder: "Briefly describe the use case, deployment or special needs for reviewers (optional)",
    applicantTitle: "Applicant",
    name: "Applicant name",
    namePlaceholder: "Enter a name",
    email: "Contact email",
    emailPlaceholder: "you@example.com",
    company: "Company / organization",
    companyPlaceholder: "Enter company or organization (optional)",
    reloadProducts: "Reload",
    submit: "Submit application",
    submitting: "Submitting…",
    footerNote: "Once submitted it enters review; track progress in 'My Licenses'.",
    delistedSuffix: " (no longer licensed)",
    errors: {
      product: "Please select a product",
      version: "Please select a version",
      edition: "Please select an edition",
      seats: "Seats must be an integer no less than 1",
      machine: "Please enter the machine code",
      name: "Please enter the applicant name",
      email: "Please enter the contact email",
      emailFormat: "Invalid email format",
      useCase: "Use case cannot exceed 500 characters",
      archived: "This product is no longer licensed, submit an available product instead.",
      submitFailed: "Submission failed, please retry",
    },
    successTitle: "Application submitted",
    successDesc: "We received your application. The result will be emailed within 1-2 business days.",
    refLabel: "Reference no.",
    copyRef: "Copy no.",
    copied: "Copied",
    detailProduct: "Product",
    detailVersion: "Version",
    detailEdition: "Edition",
    detailSeats: "Seats",
    detailMachine: "Machine code",
    detailEmail: "Contact email",
    seatsUnit: "{{count}} seats",
    nextTitle: "What happens next",
    next1Title: "Review",
    next1Desc: "Reviewers verify the product, seats and machine code",
    next2Title: "Issue license",
    next2Desc: "A dedicated license key is generated on approval",
    next3Title: "Download & activate",
    next3Desc: "Download the key in 'My Licenses' and activate devices",
    viewLicenses: "View my licenses",
    submitAnother: "Submit another",
    backHome: "Back to home",
    myTitle: "My applications",
    mySub: "Track the progress of the applications you submitted in real time.",
    pendingLabel: "Pending",
    approvedLabel: "Approved",
    rejectedLabel: "Rejected",
    stepSubmit: "Submitted",
    stepReview: "Review",
    stepNotify: "Notified",
    delistedCountTitle: "{{count}} applications involve products no longer licensed",
    delistedCountDesc: "Those products are delisted; historical applications remain viewable. If you still need a license, pick an available product in the product center and submit again.",
    loginTitle: "Sign in to track your applications",
    loginDesc: "Your applications are tied to your account — sign in to see pending, approved or rejected status anytime.",
    loginBtn: "Sign in",
    emptyTitle: "No applications yet",
    emptyDesc: "Fill in and submit an application on the left and its progress will appear here.",
    renewalTag: "Renewal",
    seatUnit: "{{count}} seats",
    submittedAt: "Submitted {{date}}",
    processedAt: "Processed {{date}}",
    appNo: "Application no.",
    productsLoadFailed: "Failed to load products, please retry",
    appsLoadFailed: "Failed to load applications, please retry",
    approvalTitle: "Approval progress",
    approvalLevel: "Level {{current}}/{{total}}",
    approvalCurrentHint: "Currently at level {{current}}/{{total}} · \"{{name}}\" is under review.",
    approvalDecisionToggle: "Expand this level's decision record",
    approvalDecisionHint: "Click a step marked with an arrow to view its approver and comment.",
    approvalDecisionApprover: "Approver",
    approvalDecisionNote: "Comment",
    approvalDecisionNoNote: "No comment provided at this level",
    approvalDecisionTime: "Time",
    timelineTitle: "Approval journey timeline",
    timelineToggle: "Show approval journey",
    timelineCollapse: "Hide approval journey",
    timelineSubmitted: "Application submitted",
    timelineStart: "Multi-level approval started",
    timelineStartDesc: "The application entered an approval flow with {{total}} levels.",
    timelineStepApproved: "Level {{order}} approved · {{name}}",
    timelineStepRejected: "Level {{order}} rejected · {{name}}",
    timelineIssued: "All levels approved · License issued",
    timelineIssuedDesc: "The license has been generated and is ready to download.",
    timelineRejected: "Approval rejected · Flow ended",
    timelineRejectedDesc: "The application was rejected and the flow ended here.",
    timelinePending: "In progress",
    timelinePendingDesc: "Currently at level {{current}}/{{total}} · \"{{name}}\" is under review.",
    timelineExportText: "Export text",
    timelineExportCsv: "Export CSV",
    timelineExportTitle: "Export the whole approval journey as a file to archive or share with support",
    timelineExportDone: "Approval journey exported",
    timelineExportFileName: "approval-journey",
    timelineColTime: "Time",
    timelineColEvent: "Event",
    timelineColApprover: "Approver",
    timelineColNote: "Comment",
  },
  products: {
    breadcrumbHome: "Home",
    badge: "Product center",
    title: "Licensable genuine software & versions",
    subtitle: "Browse the platform's software, review version history and editions, and apply for a license in one click.",
    searchPlaceholder: "Search name, category or summary…",
    clearSearch: "Clear search",
    totalUnit: "{{count}} products",
    sortLabel: "Sort by",
    sortRecommend: "Recommended",
    sortRating: "Top rated",
    sortDownloads: "Most licensed",
    sortVersion: "Newest version",
    categoryAll: "All",
    emptyTitle: "No matching products",
    emptyDesc: "Try another keyword or category.",
    resetFilter: "Reset filters",
    reload: "Reload",
    loadFailed: "Failed to load products, please retry",
    downloadsUnit: "{{count}} licensed",
    versionsUnit: "{{count}} versions",
    latest: "Latest {{version}}",
    versionDetail: "Version details",
    apply: "Apply",
    editionsTitle: "Available editions",
    customQuote: "Custom quote",
    perSeat: "per seat / year",
    customPlan: "Tailored licensing plan",
    versionHistory: "Version history",
    close: "Close",
    closeDetail: "Close details",
    applyThis: "Apply for this product",
    recSameCategory: "Available in the same category ({{category}})",
    recGeneric: "Available products",
  },
  notifications: {
    breadcrumbHome: "Home",
    title: "Notifications",
    subtitle: "Approval results, license renewals and expiry reminders are gathered here so you can stay on top of licensing changes.",
    markAllRead: "Mark all as read",
    unread: "Unread",
    emptyTitle: "No notifications yet",
    emptyDesc: "When your applications get a review result, or licenses near expiry or renew, notifications appear here.",
    viewLicenses: "View my licenses",
    loadFailed: "Failed to load notifications, please retry",
    reload: "Reload",
  },
  settings: {
    breadcrumbHome: "Home",
    title: "Settings",
    subtitle: "Manage your account profile and login security — update your name, company and password.",
    loading: "Loading your account",
    securityTitle: "Security tips",
    securityTip1: "Use a strong password with letters, numbers and symbols",
    securityTip2: "Do not reuse the same password across platforms",
    securityTip3: "License keys are sensitive — do not share them publicly",
    quickTitle: "Shortcuts",
    quickLicenses: "My licenses",
    quickApply: "Submit an application",
    profileBasic: "Basic profile",
    profileName: "Name",
    profileNamePlaceholder: "Enter your name",
    profileCompany: "Company / organization",
    profileCompanyPlaceholder: "Enter company or organization",
    profileEmail: "Login email (read-only)",
    profileCreated: "Registered at",
    profileSave: "Save changes",
    profileSaving: "Saving…",
    profileUnsaved: "Unsaved changes",
    profileUpdated: "Profile updated",
    profileNameRequired: "Please enter a name",
    profileUnnamed: "Unnamed user",
    roleCustomer: "Customer",
    roleAdmin: "Administrator",
    passwordTitle: "Account security",
    showPassword: "Show password",
    hidePassword: "Hide password",
    currentPassword: "Current password",
    currentPasswordPlaceholder: "Enter your current password",
    newPassword: "New password",
    newPasswordPlaceholder: "At least 6 characters",
    confirmPassword: "Confirm new password",
    confirmPasswordPlaceholder: "Re-enter the new password",
    updatePassword: "Update password",
    updatingPassword: "Updating…",
    passwordUpdated: "Password updated",
    errCurrent: "Please enter your current password",
    errMin: "New password must be at least 6 characters",
    errMismatch: "The two new passwords do not match",
    errSame: "New password cannot match the current one",
    errFailed: "Failed to change password",
    saveFailed: "Save failed, please retry",
  },
  apikeys: {
    breadcrumbHome: "Home",
    breadcrumbAdmin: "Admin",
    badge: "Open platform · access governance",
    title: "API Clients",
    subtitle: "Issue API keys for apps calling the validation endpoint, set rate limits and daily quotas, and review every call log.",
    backToAdmin: "Back to admin",
    reload: "Reload",
    docs: "Integration docs",
    statClients: "Clients",
    statActiveKeys: "Active keys",
    statCalls24h: "Calls (24h)",
    statErrorRate: "Failure rate (24h)",
    usageTitle: "Call insights",
    usageSub: "14-day call trend and per-client call ranking, so you can see who is using it and where the peaks are.",
    usageSubWithDays: "{{days}}-day call trend and per-client call ranking, so you can see who is using it and where the peaks are.",
    usageWindowShort: "{{days}}d",
    usageWindowTotal: "{{count}} calls in {{days}} days",
    trendTitle: "{{days}}-day call trend",
    trendLegendOk: "Success",
    trendLegendFail: "Failed",
    trendLegendBlocked: "Rate limited",
    trendDayTotal: "{{count}} calls",
    trendPeak: "Daily peak {{count}}",
    trendEmpty: "No call data yet",
    rankTitle: "Calls by client",
    rankTotal: "{{count}} calls in total",
    rankEmpty: "No clients to rank yet",
    rankCalls: "{{count}} calls",
    rankShare: "{{pct}}%",
    rankBlocked: "{{count}} blocked",
    rankShowAll: "Show all {{count}}",
    rankCollapse: "Collapse",
    rankClickHint: "Click a client to filter the call logs below",
    rankActive: "Filtered",
    policyTitle: "Validation auth policy",
    policySub: "Switch between mandatory key and transitional compatibility to migrate legacy clients smoothly.",
    policyRequired: "Mandatory key",
    policyOptional: "Transitional",
    policyCurrent: "Current policy",
    policyRequiredDesc: "Every request must carry a valid API key or it returns 401; keyless requests are also logged.",
    policyRequiredWarn: "Legacy clients without a key will get 401 immediately — issue keys for them before switching.",
    policyOptionalDesc: "Requests without an API key are allowed through (not attributed to any client); requests with a key are still authenticated and rate limited.",
    policyOptionalWarn: "In transitional mode keyless requests bypass rate limits and cannot be attributed, so keep it short-term during migration.",
    policySwitched: "Auth policy updated",
    policySwitchFailed: "Failed to update policy, please retry",
    policyConfirmTitle: "Switch auth policy?",
    policyConfirmToRequired: "After switching, every request without an x-api-key header returns 401 immediately. Make sure existing clients already have keys and are upgraded.",
    policyConfirmToOptional: "After switching, requests without an API Key are allowed through (no ownership recorded, no rate limiting). Recommended only briefly during migration.",
    policyConfirmBtn: "Confirm switch",
    policyHistoryTitle: "Policy change history",
    policyHistorySub: "Review every auth policy adjustment with actor and direction, to trace accidental switches.",
    policyHistoryEmpty: "No policy changes yet",
    policyHistoryEmptyDesc: "Every auth policy adjustment will be recorded here.",
    logCopyPrefixes: "Copy all key prefixes",
    logCopyPrefixesTitle: "Copy every key prefix under this client for batch reconciliation",
    logCopyPrefixesEmpty: "This client has no keys to copy",
    logCopiedPrefixes: "Copied {{count}} prefixes",
    logKeyAll: "All keys",
    logKeyFilterLabel: "Key drill-down",
    logKeyDetailTitle: "Drilled key",
    logKeyCalls: "Calls in window",
    clientsTitle: "Connected apps",
    clientsSub: "Each app can hold multiple keys, all managed under the app.",
    createClient: "New client",
    noClient: "No clients yet",
    noClientDesc: "Create a client to start issuing API keys for it.",
    clientKeys: "{{count}} keys",
    clientLastUsed: "Last call {{time}}",
    clientNeverUsed: "No calls yet",
    suspended: "Suspended",
    activeStatus: "Active",
    suspend: "Suspend",
    resume: "Resume",
    edit: "Edit",
    delete: "Delete",
    addKey: "Issue key",
    noKey: "This client has no keys yet",
    keyName: "Key name",
    keyPrefix: "Key prefix",
    keyRate: "Rate limit",
    keyQuota: "Daily quota",
    keyStatus: "Status",
    keyLastUsed: "Last used",
    keyExpires: "Expires",
    keyNever: "Never",
    keyUnlimited: "Unlimited",
    keyPermanent: "Never",
    rateUnit: "{{count}}/min",
    quotaUnit: "{{count}}/day",
    revoke: "Revoke",
    enable: "Enable",
    keyRevokedStatus: "Revoked",
    keyActiveStatus: "Active",
    confirmDeleteClient: "Deleting this client also removes all its keys. Continue?",
    confirmDeleteKey: "Delete this key? This cannot be undone.",
    newClientTitle: "New client",
    editClientTitle: "Edit client",
    fieldName: "Client name",
    fieldNamePlaceholder: "e.g. Xinghe Desktop Client",
    nameRequired: "Please enter a client name",
    fieldOwner: "Owner",
    fieldOwnerPlaceholder: "e.g. Xinghe Software · Li",
    fieldEmail: "Contact email",
    fieldEmailPlaceholder: "ops@example.com",
    fieldDesc: "Purpose",
    fieldDescPlaceholder: "Briefly describe how this app calls the endpoint (optional)",
    cancel: "Cancel",
    save: "Save",
    saving: "Saving…",
    create: "Create",
    newKeyTitle: "Issue API Key",
    newKeySubtitle: "Issue a new API key for this client.",
    keyIssuedTitle: "API Key generated",
    keyIssuedDesc: "Copy and store it now. For security, the plaintext key is shown only once.",
    copyKey: "Copy key",
    copied: "Copied",
    done: "I saved it",
    fieldRate: "Rate limit (requests/min)",
    fieldQuota: "Daily quota (requests/day, 0 = unlimited)",
    fieldExpires: "Expiry (optional)",
    keyNameDefault: "Default key",
    logsTitle: "Call logs",
    logsSub: "Every validation call's client, key, result and latency, for troubleshooting and reconciliation.",
    logClientAll: "All clients",
    logStatusAll: "All results",
    logStatusOk: "Success",
    logStatusFail: "Failed",
    logStatusBlocked: "Rate limited",
    logRangeAll: "All time",
    logRangeToday: "Today",
    logRange24h: "Last 24h",
    logRange7d: "Last 7 days",
    logClear: "Clear filters",
    logShowAll: "Show all {{count}}",
    logCollapse: "Collapse",
    logExport: "Export logs",
    logEmpty: "No call logs yet",
    logEmptyDesc: "Once a client calls the validation endpoint, every request is recorded here.",
    logNoMatch: "No logs under current filters",
    logNoMatchDesc: "Try relaxing the client, result or time range.",
    colTime: "Time",
    colClient: "Client",
    colKey: "Key",
    colLicense: "License",
    colResult: "Result",
    colLatency: "Latency",
    colIp: "Source IP",
    latencyUnit: "{{ms}} ms",
    resultOk: "OK",
    unknown: "Unknown",
    loadFailed: "Failed to load client data, please retry",
    actionFailed: "Action failed, please retry",
    created: "Client created",
    updated: "Client updated",
    deleted: "Client deleted",
    statusChanged: "Client status updated",
    keyCreated: "API Key issued",
    keyUpdated: "Key settings updated",
    keyRevoked: "Key revoked",
    keyEnabled: "Key enabled",
    keyDeleted: "Key deleted",
    exported: "Exported {{count}} call logs",
  },
  approvals: {
    breadcrumbHome: "Home",
    breadcrumbAdmin: "Admin",
    badge: "Approval governance · Webhooks",
    title: "Approval flows & webhooks",
    subtitle: "Configure cascading multi-level approval flows, process pending applications step by step with auto-issue, and deliver authorization events to your systems via webhooks.",
    backToAdmin: "Back to admin",
    reload: "Reload",
    tabFlow: "Approval flows",
    tabWebhook: "Webhooks",
    statWorkflows: "Flows",
    statPending: "In progress",
    statDone: "Completed",
    statEndpoints: "Endpoints",
    workflowsTitle: "Approval flows",
    workflowsSub: "Match flows by seat threshold, cascade through levels, and auto-issue on final approval.",
    newWorkflow: "New flow",
    editWorkflow: "Edit flow",
    workflowsEmpty: "No approval flows yet",
    workflowsEmptyDesc: "Create a flow to start multi-level approvals for pending applications.",
    enabled: "Enabled",
    disabled: "Disabled",
    minSeatsTag: "Seats ≥ {{count}}",
    allSeatsTag: "Any seats",
    edit: "Edit",
    delete: "Delete",
    roleAdmin: "Admin",
    roleStaff: "Staff",
    fieldName: "Flow name",
    fieldNamePlaceholder: "e.g. Standard two-level approval",
    fieldDesc: "Description",
    fieldDescPlaceholder: "Briefly describe when this flow applies (optional)",
    fieldMinSeats: "Seat threshold",
    fieldMinSeatsHint: "Only applications with seats at or above this value match this flow.",
    fieldEnabled: "Status",
    stepsLabel: "Approval steps (cascade in order)",
    addStep: "Add step",
    stepNamePlaceholder: "Step name, e.g. Business review",
    stepDefaultFirst: "Staff review",
    save: "Save",
    saving: "Saving…",
    cancel: "Cancel",
    workflowNameRequired: "Please enter a flow name",
    workflowStepsRequired: "Configure at least one approval step",
    workflowCreated: "Flow created",
    workflowUpdated: "Flow updated",
    workflowDeleted: "Flow deleted",
    deleteWorkflow: "Delete flow",
    confirmDeleteWorkflow: "Deleting this flow also removes its steps; existing requests are unaffected. Continue?",
    requestDelete: "Delete",
    saveFailed: "Save failed, please retry",
    actionFailed: "Action failed, please retry",
    pendingStartTitle: "Awaiting approval",
    pendingStartSub: "These pending applications have not entered a flow yet; pick one to start multi-level approval.",
    pendingStartEmpty: "No applications awaiting approval.",
    startApproval: "Start approval",
    startSuccess: "Multi-level approval started",
    requestsTitle: "Approval requests",
    requestsSub: "Cascading approval requests with current progress and per-level decisions.",
    requestsCount: "{{count}} total",
    requestsEmpty: "No approval requests yet.",
    statusPending: "In progress",
    statusApproved: "Approved",
    statusRejected: "Rejected",
    seatUnit: "{{count}} seats",
    renewalTag: "Renewal",
    submittedAt: "Submitted {{date}}",
    unknown: "Unknown",
    currentStep: "Current step",
    approve: "Approve",
    reject: "Reject",
    approveTitle: "Approve this level?",
    rejectTitle: "Reject this application?",
    approveDesc: "If more levels remain it cascades to the next approver; at the final level the license is issued / renewed automatically and the applicant is notified.",
    rejectDesc: "Rejecting ends the flow and marks the application as rejected; the applicant is notified.",
    noteLabel: "Comment (optional)",
    notePlaceholder: "Approval comment or rejection reason…",
    confirm: "Confirm",
    approveSuccess: "Level approved",
    rejectSuccess: "Application rejected",
    endpointsTitle: "Webhook endpoints",
    endpointsSub: "Subscribe to authorization events and deliver them to your systems; add a signing secret to verify the source.",
    newEndpoint: "New endpoint",
    editEndpoint: "Edit endpoint",
    endpointsEmpty: "No webhook endpoints yet.",
    endpointEnabled: "Enabled",
    endpointPaused: "Paused",
    endpointStatusChanged: "Endpoint status updated",
    signedTag: "Signed",
    test: "Test",
    pause: "Pause",
    resume: "Resume",
    delete: "Delete",
    endpointName: "Endpoint name",
    endpointNamePlaceholder: "e.g. Order system callback",
    endpointUrl: "Callback URL",
    endpointSecret: "Signing secret (optional)",
    endpointSecretPlaceholder: "Used for HMAC-SHA256 signing; leave blank to skip",
    endpointSecretHint: "Verify header x-licensehub-signature (HMAC-SHA256 over the request body).",
    endpointEvents: "Subscribed events",
    endpointNameRequired: "Please enter an endpoint name",
    endpointUrlRequired: "Callback URL must start with http:// or https://",
    endpointEventsRequired: "Subscribe to at least one event",
    endpointCreated: "Endpoint created",
    endpointUpdated: "Endpoint updated",
    endpointDeleted: "Endpoint deleted",
    confirmDeleteEndpoint: "Deleting this endpoint also removes its deliveries. Continue?",
    event_approval_step_approved: "Approval level approved (cascades to next)",
    event_approval_completed: "Final approval completed (license issued)",
    event_approval_rejected: "Approval rejected",
    deliveriesTitle: "Delivery log",
    deliveriesSub: "Result of every webhook delivery; failed ones can be retried in one click.",
    deliveryAllEndpoints: "All endpoints",
    deliveriesEmpty: "No deliveries yet.",
    deliverySuccess: "Success",
    deliveryFailed: "Failed",
    deliveryPending: "Pending",
    colDeliveryTime: "Time",
    colEndpoint: "Endpoint",
    colEvent: "Event",
    colDeliveryStatus: "Result",
    colAttempts: "Attempts",
    colResponse: "Response",
    colActions: "Actions",
    retry: "Retry",
    testDone: "Test delivery succeeded",
    testFailed: "Test delivery failed: {{error}}",
    retryDone: "Retry succeeded",
    stepSlaLabel: "Reminder after (hours)",
    stepEscalateLabel: "Auto-escalate after (hours)",
    stepTimeoutHint: "Past the reminder threshold an in-app reminder is sent; if escalation is enabled, it auto-escalates to the next level (0 = no auto-escalation).",
    stepSlaChip: "Remind approver after {{hours}}h",
    stepEscalateChip: "Auto-escalate to next level after {{hours}}h",
    timeoutHint: "Opening this page runs a scan once; you can also manually check which approval steps are overdue and apply reminder / escalation rules.",
    checkTimeouts: "Check timeouts",
    timeoutNone: "No overdue approval steps",
    timeoutResult: "Timeout scan done: {{reminded}} reminded · {{escalated}} escalated",
    overdueTag: "Overdue {{hours}}h",
    escalatedTag: "Escalated",
    remindedTag: "Reminded",
    useBuiltinReceiver: "Use built-in receiver",
    builtinReceiverHint: "The built-in receiver verifies the x-licensehub-signature header and event payload format; results show in the Response column of the delivery log below.",
    deliveryRetrying: "Retrying",
    endpointSuccessRate: "Delivery success rate",
    endpointStatTotal: "{{count}} total",
    autoRetryHint: "Failed deliveries are retried automatically with exponential backoff (30s / 2m / 8m, up to 4 attempts); opening this page processes due retries once.",
    processRetries: "Process due retries",
    retriesNone: "No due retries right now",
    retriesProcessed: "Processed {{processed}} due retries ({{succeeded}} succeeded)",
    retryScheduled: "Auto-retry in {{time}}",
    bulkTimeoutTitle: "Overall default timeouts",
    bulkTimeoutHint: "Fill once, apply to every step",
    bulkSlaLabel: "Remind after (h)",
    bulkEscalateLabel: "Escalate after (h)",
    bulkApply: "Apply to all steps",
    bulkTimeoutApplied: "Applied timeouts to all {{count}} steps",
    healthTitle: "Endpoint health overview",
    healthSub: "Success rate, average response time and latest delivery for every receiver, least stable first.",
    healthEmpty: "No endpoints to summarize.",
    healthColEndpoint: "Receiver",
    healthColRate: "Success rate",
    healthColLatency: "Avg response time",
    healthColTotal: "Deliveries",
    healthColFailed: "Failed",
    healthColLast: "Latest delivery",
    healthLeastStable: "Least stable",
    healthNoDelivery: "No deliveries",
    healthAvgUnit: "{{ms}} ms",
    healthWindowLabel: "Time window",
    healthWindow24h: "Last 24h",
    healthWindow7d: "Last 7 days",
    healthWindow30d: "Last 30 days",
    healthWindowHint: "Only reflect deliveries within the selected window, so recently degraded receivers stand out.",
    autoDegradeHint: "An endpoint is auto-paused and admins are notified after {{threshold}} consecutive failures, to avoid wasting calls and spamming logs.",
    endpointConsecutive: "{{count}} consecutive failures",
    endpointAutoPaused: "Auto-paused",
    endpointNeedsAttention: "Check receiver",
    endpointNeedsAttentionHint: "This endpoint's replay after resume has failed several cycles in a row; check the receiver before resuming to avoid repeated resets.",
    markFixed: "Mark as fixed",
    markFixedTitle: "Confirm the receiver is fixed to clear the 'Check receiver' degradation flag and reset the post-resume failure count",
    markFixedDone: "Marked as fixed, degradation flag cleared",
    undoMarkFixed: "Undo mark-fixed",
    undoMarkFixedTitle: "Marked by mistake? Restore the 'Check receiver' degradation flag and the post-resume failure count",
    undoMarkFixedDone: "Mark-fixed undone, degradation flag restored",
    recoverPrecheck: "Pre-check & resume",
    recoverPrecheckRunning: "Pre-checking…",
    recoverPrecheckOk: "Pre-check passed, endpoint resumed",
    recoverPrecheckFail: "Pre-check failed, endpoint stays paused: {{error}}",
    recoverPrecheckTitle: "Send a test delivery before resuming — only enable it if the probe passes, so a freshly fixed endpoint does not immediately fail again",
    recoverPrecheckHint: "For an auto-paused endpoint, 'Pre-check & resume' sends a test delivery first, only re-enables it if it passes, and then auto-replays all pending retries.",
    recoverPrecheckReplayOk: "Pre-check passed, endpoint resumed and {{count}} pending retries auto-replayed",
    recoverPrecheckReplayFail: "Pre-check passed and endpoint resumed; {{success}} of {{count}} replays succeeded, the rest can be retried manually later",
    recoverPrecheckDegraded: "Pre-check passed, but replays kept failing after resume ({{count}} this round). Check the receiver before resuming to avoid repeated resets.",
    exportHealth: "Export health snapshot CSV",
    exportHealthTitle: "Export each receiver's success rate / avg response time / failures for the current window as CSV",
    exportHealthFileName: "endpoint-health-snapshot",
    exportEvents: "Export event history CSV",
    exportEventsTitle: "Export the currently filtered endpoint health events (auto-pause / resume / pre-check / reset) as a CSV archive",
    exportEventsFileName: "endpoint-health-events",
    eventColTime: "Time",
    eventColType: "Event type",
    eventColEndpoint: "Receiver",
    eventColDetail: "Detail",
    eventColActor: "Actor",
    healthEventTitle: "Health event timeline",
    healthEventSub: "Records the time and reason of every auto-pause / manual resume / failure-streak reset, for after-the-fact tracing.",
    healthEventEmpty: "No health events yet.",
    eventAutoPaused: "Auto-paused",
    eventManualResume: "Manually resumed",
    eventManualPause: "Manually paused",
    eventFailuresReset: "Failure streak reset",
    eventProbePassed: "Pre-check passed",
    eventProbeFailed: "Pre-check failed",
    eventResumeReplay: "Replay after resume",
    eventReplayDegraded: "Replay keeps failing",
    eventMarkedFixed: "Marked as fixed",
    eventUndidFixed: "Mark-fixed undone",
    healthEventAllEndpoints: "All endpoints",
    healthEventAllTypes: "All events",
    healthEventNoMatch: "No health events under current filters.",
  },
  helpFeedback: {
    breadcrumbHome: "Home",
    breadcrumbAdmin: "Admin",
    badge: "Help content quality",
    title: "Help feedback",
    subtitle: "Aggregate customers' helpful / not-helpful ratings on FAQ answers to find content that most needs adding or rewriting, and fix high-frequency confusion first.",
    backToAdmin: "Back to admin",
    reload: "Reload",
    loadFailed: "Failed to load feedback, please retry",
    statFeedback: "Total feedback",
    statHelpful: "Helpful",
    statNotHelpful: "Not helpful",
    statRate: "Not-helpful rate",
    topTitle: "Content that needs attention",
    topSub: "Sorted by not-helpful count, high to low; the ones on top deserve rewriting first.",
    topEmpty: "No not-helpful feedback yet",
    topEmptyDesc: "Once a customer marks an answer not helpful, it ranks here by count.",
    notHelpfulUnit: "{{count}} not helpful",
    helpfulUnit: "{{count}} helpful",
    tableTitle: "All feedback detail",
    tableSub: "Helpful and not-helpful counts and ratios aggregated per question.",
    colQuestion: "Question",
    colCategory: "Category",
    colHelpful: "Helpful",
    colNotHelpful: "Not helpful",
    colRate: "Not-helpful rate",
    colTotal: "Feedback",
    colLast: "Latest feedback",
    colStatus: "Status",
    exportTop: "Export CSV",
    optimizeBadge: "Needs work",
    resolvedBadge: "Resolved",
    optimizeCount: "{{count}} need work",
    markResolved: "Mark resolved",
    unmarkResolved: "Undo resolved",
    onlyOptimize: "Needs work only",
    statusOptimize: "Needs work",
    statusResolved: "Resolved",
    statusWatching: "Watching",
    previewTitle: "Preview this answer in a new window",
    sortNotHelpful: "By not helpful",
    sortRate: "By rate",
    sortTotal: "By volume",
    allCategories: "All categories",
    noCategory: "Uncategorized",
    unknownQuestion: "Unknown question",
    totalUnit: "{{count}} total",
    empty: "No feedback yet",
    emptyDesc: "Once customers rate answers helpful / not helpful in the help center, the data aggregates here.",
    colNote: "Optimization note",
    colOwner: "Owner",
    editAnswer: "Edit answer",
    editTitle: "Edit FAQ content",
    editSub: "Edit this FAQ's Chinese and English copy directly; it goes live for all visitors once saved, with no code change. Leave a field empty to keep the built-in default.",
    contentPreview: "Preview current answer",
    contentFieldEmpty: "Empty fields fall back to the built-in default copy",
    contentLangZh: "中文",
    contentLangEn: "English",
    contentQuestion: "Question",
    contentAnswer: "Answer",
    contentSave: "Save & publish",
    contentSaving: "Saving…",
    contentReset: "Reset to default",
    contentCancel: "Cancel",
    contentEditedBadge: "Edited",
    tabEdit: "Edit content",
    tabHistory: "Version history",
    draftBadge: "Draft",
    saveDraft: "Save draft",
    publish: "Publish",
    diffTitle: "Change diff",
    diffCount: "{{count}} changes",
    diffNoChange: "No changes",
    diffBefore: "Before",
    diffAfter: "After",
    diffToggle: "View diff",
    diffDefault: "(default copy)",
    versionsEmpty: "No versions yet",
    versionsEmptyDesc: "Each save or publish leaves a change record here that you can roll back anytime.",
    unknownEditor: "Unknown",
    actionPublish: "Published",
    actionDraft: "Draft",
    actionReset: "Reset",
    actionRollback: "Rollback",
    rollback: "Roll back to this version",
    resolveTitle: "Mark as resolved",
    resolveHint: "Record what changed and who owns it to build a content optimization ledger for later review and handover.",
    resolveNoteLabel: "Optimization note",
    resolveNotePlaceholder: "e.g. Added where to find the machine code, with a screenshot",
    resolveOwnerLabel: "Owner",
    resolveOwnerPlaceholder: "e.g. Content team · Wang",
    resolveConfirm: "Mark resolved",
    resolveSaving: "Saving…",
    settingsTitle: "Needs-work rule",
    settingsSub: "Define what counts as a high not-helpful ratio. An FAQ is auto-flagged as Needs work only when both the ratio and the count thresholds are met.",
    settingsRateLabel: "Not-helpful ratio threshold",
    settingsRateHint: "Not-helpful ÷ total feedback must reach this ratio",
    settingsMinLabel: "Minimum not-helpful count",
    settingsMinHint: "Only counts once the total reaches this number, to avoid single-vote noise",
    settingsSave: "Save rule",
    settingsSaving: "Saving…",
    settingsCurrent: "Current rule: ratio ≥ {{rate}}% and not-helpful ≥ {{min}}",
    ledgerTitle: "Optimization ledger",
    ledgerSub: "Resolved FAQs with what changed, who owns it, and who marked it, all in one view.",
    ledgerEmpty: "No optimization records yet",
    ledgerEmptyDesc: "Once you mark a Needs-work question as resolved, its record lands here.",
    ledgerCount: "{{count}} resolved",
    ledgerColQuestion: "Question",
    ledgerColNote: "Note",
    ledgerColOwner: "Owner",
    ledgerColBy: "Marked by",
    ledgerColAt: "Marked at",
    ledgerColAction: "Action",
    ledgerEditNote: "Edit note",
    ledgerUndo: "Undo resolved",
    ledgerNoNote: "No note",
    notePrefix: "Note",
    ownerPrefix: "Owner",
    markedBy: "Marked by {{name}}",
    weeklyExport: "Export weekly report",
    weeklyExportTitle: "Export the content optimization weekly report CSV (with each owner's pending/resolved workload)",
    weeklyTitle: "Content optimization weekly report",
    weeklyOwnerSection: "Owner workload summary",
    weeklyColOwner: "Owner",
    weeklyColPending: "Needs work",
    weeklyColResolved: "Resolved",
    weeklyColTotal: "Total",
    weeklyColQuestions: "FAQs",
    weeklyColStatus: "Status",
    weeklyDetailSection: "Needs work / resolved detail",
    weeklyUnassigned: "Unassigned",
    weeklyPendingChip: "{{count}} pending",
    weeklyResolvedChip: "{{count}} resolved",
    filterEditor: "Operator",
    filterAction: "Action",
    filterAllEditors: "All operators",
    filterAllActions: "All actions",
    exportLedger: "Export change ledger",
    exportLedgerTitle: "Export the currently filtered change records as CSV for monthly archival",
    ledgerColTime: "Time",
    ledgerColQuestion: "Question",
    ledgerColEditor: "Operator",
    ledgerColAction: "Action",
    ledgerColFields: "Changed fields",
    versionFilterEmpty: "No versions under current filters",
    onlyDraft: "Drafts only",
    batchPublish: "Publish all drafts",
    batchPublishCount: "Publish {{count}} drafts",
    batchPublishTitle: "Confirm batch publish",
    batchPublishDesc: "These {{count}} FAQ drafts go live for visitors immediately:",
    batchPublishConfirm: "Confirm publish",
    batchPublishing: "Publishing…",
    batchPublishDone: "Published {{count}} drafts",
    draftOnlyEmpty: "No drafts to publish",
    draftOnlyEmptyDesc: "Saved drafts are listed here so you can push them live in one go.",
    tip: "For answers with a high not-helpful ratio, pair the related ticket content to add more concrete steps or screenshots.",
  },
};